// extracted by mini-css-extract-plugin
export var badge = "_ht-2";
export var detailsPanel = "_ht-0";
export var resultRow = "_ht-1";